export function isFresh(ts: number, ttlMs: number): boolean {
  return Date.now() - ts < ttlMs;
}

export function pruneLRU<T extends { ts: number }>(dict: Record<string, T>, maxSize: number) {
  const keys = Object.keys(dict);
  if (keys.length <= maxSize) return;
  const sorted = keys.sort((a, b) => dict[b].ts - dict[a].ts);
  const keep = new Set(sorted.slice(0, maxSize));
  for (const k of keys) {
    if (!keep.has(k)) delete dict[k];
  }
}
